import { useState } from 'react';

/**
 * ダイアログの表示状態を管理するカスタムフック。
 *
 * @returns {object} ダイアログ管理オブジェクト。
 * @returns {boolean} isEditMode - 編集モードが有効かどうか
 * @returns {boolean} showDeleteAlertDialog - 削除確認ダイアログの表示状態。
 * @returns {boolean} showCancelAlertDialog - キャンセル確認ダイアログの表示状態。
 * @returns {function} toggleEditMode - 編集モードの切り替え関数。
 * @returns {function} toggleDeleteAlert - 削除確認ダイアログの表示切替関数。
 * @returns {function} toggleCancelAlert - キャンセル確認ダイアログの表示切替関数。
 */
const useDialogControl = () => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [showDeleteAlertDialog, setShowDeleteAlertDialog] = useState(false);
  const [showCancelAlertDialog, setShowCancelAlertDialog] = useState(false);

  const toggleEditMode = () => setIsEditMode(!isEditMode);
  const toggleDeleteAlert = () =>
    setShowDeleteAlertDialog(!showDeleteAlertDialog);
  const toggleCancelAlert = () =>
    setShowCancelAlertDialog(!showCancelAlertDialog);

  return {
    isEditMode,
    showDeleteAlertDialog,
    showCancelAlertDialog,
    toggleEditMode,
    toggleDeleteAlert,
    toggleCancelAlert,
  };
};

export default useDialogControl;
